import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M2 3.5c-.275 0-.5.225-.5.5v.69l5.39 4.426a1.75 1.75 0 0 0 2.223 0L14.5 4.69V4c0-.275-.225-.5-.5-.5zm-.5 3.131V12c0 .275.225.5.5.5h12c.275 0 .5-.225.5-.5V6.631l-4.437 3.644a3.25 3.25 0 0 1-4.126 0zM0 4c0-1.103.897-2 2-2h12c1.103 0 2 .897 2 2v8c0 1.103-.897 2-2 2H2c-1.103 0-2-.897-2-2z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }